import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';

import { locationType, pageLinkType } from 'types';
import { baseSpacing } from 'css/constants';
import PropTypes from 'prop-types';
import { COLOURS } from '@sohonet/ui-components/constants';

// TODO: Move this to @sohonet/ui-components (and use themes instead)
// react-router's `NavLink` uses `.active` by default
const NavItemPrimitive = styled(NavLink)`
  display: block;
  padding: ${baseSpacing / 3}px ${baseSpacing}px;
  color: ${COLOURS.SOHO_GREY.LIGHT3};
  text-decoration: none;

  &:hover,
  &:focus,
  &:active {
    background-color: rgb(255 255 255 / 80%);
    color: ${COLOURS.SOHO_GREY.DARK1};
    font-weight: 400;
  }

  &.active {
    background-color: ${COLOURS.SOHO_GREY.LIGHT5};
    color: ${COLOURS.SOHO_GREY.DARK1};
  }
`;

const NavItem = ({ item, location, exact, isActive }) => (
  <NavItemPrimitive
    exact={exact}
    isActive={isActive}
    to={{ pathname: item.url, search: location.search }}
  >
    {item.text}
  </NavItemPrimitive>
);

NavItem.propTypes = {
  item: pageLinkType.isRequired,
  location: locationType.isRequired,
  exact: PropTypes.bool,
  isActive: PropTypes.func
};

NavItem.defaultProps = {
  exact: true
};

export default NavItem;
